const _1 = "1"
const _2 = "2"
const _3 = "3"
const _4 = "4"
const _5 = "5"
const _6 = "6"
const _7 = "7"
const _auto = "auto"
const config = { "1": _1, "2": _2, "3": _3, "4": _4, "5": _5, "6": _6, "7": _7, "auto": _auto,  }
export { config as default, _1, _2, _3, _4, _5, _6, _7, _auto }